import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

const NavbarLink = ({ children, to }) => {
  return (
    <Link to={to} className='nav-item nav-link' activeClassName='active'>
      {children}
    </Link>
  )
}

NavbarLink.propTypes = {
  to: PropTypes.string.isRequired,
}

export default NavbarLink
